function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "a",
  d: "M405.022 131.817c1.27-5.737 2.068-11.62 2.068-17.732 0-45.015-36.459-81.49-81.418-81.49-12.506 0-24.197 3.016-34.798 8.084C273.141 16.037 244.319 0 211.687 0c-42.745 0-78.976 27.462-92.23 65.73-1.84-.131-3.6-.539-5.472-.539-44.959 0-81.418 36.475-81.418 81.49 0 5.247.603 10.381 1.563 15.368C13.532 176.815 0 200.854 0 228.137c0 45.047 36.443 81.521 81.418 81.521 18.433 0 35.238-6.372 48.883-16.705 14.851 19.932 38.348 33.003 65.102 33.003 13.174 0 25.451-3.439 36.443-9.012 10.16 33.426 40.84 57.906 77.542 57.906 44.976 0 81.418-36.475 81.418-81.49 44.976 0 81.418-36.474 81.418-81.521 0-40.109-29.033-73.275-67.202-80.022z"
}), /*#__PURE__*/React.createElement("path", {
  id: "c",
  d: "M.11.243h10.763V29.27H.11z"
}), /*#__PURE__*/React.createElement("path", {
  id: "e",
  d: "M.286.16h28.831v11.009H.286z"
}), /*#__PURE__*/React.createElement("path", {
  id: "g",
  d: "M0 .24h28.832v11.009H0z"
}));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(81.843)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "b",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#a"
})), /*#__PURE__*/React.createElement("use", {
  fill: "#C5C7C8",
  xlinkHref: "#a"
}), /*#__PURE__*/React.createElement("g", {
  mask: "url(#b)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#FFE200",
  fillRule: "nonzero",
  d: "M302.2 137.61c-19.419-33.634-62.426-45.158-96.06-25.74-33.635 19.42-45.15 62.706-25.614 96.275 9.7 16.668 25.208 27.868 42.48 32.52 13.445 3.622 25.763 10.568 35.63 20.392l15.397 15.326 39.92-23.048-5.28-19.886c-3.65-13.748-3.404-28.197.394-41.905 4.857-17.535 2.949-36.932-6.867-53.934"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M299.049 194.229c4.377-4.377 15.067-36.9-18.89-69.922-22.246-21.636-47.59-17.87-57.824-11.962-10.234 5.909-24.834 16.851 16.34 63.7 33.903 38.576 55.997 22.56 60.374 18.184z",
  opacity: 0.395
}), /*#__PURE__*/React.createElement("path", {
  fill: "#5F6469",
  d: "M315.85 280.6l-19.462 11.237c-5.515 3.184-12.584 1.836-15.882-3.149l-13.158-18.996 43.92-25.733 9.796 21.313c2.669 5.348.302 12.144-5.213 15.328"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#444A4F",
  d: "M303.444 287.77l-13.592 7.84c-2.558 1.477-7.097-1.331-10.226-6.413l-12.278-19.505 20.262-11.871 15.834 29.95z"
}), /*#__PURE__*/React.createElement("g", {
  transform: "rotate(-30 231.905 -297.034)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "d",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#c"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#FFE200",
  fillRule: "nonzero",
  d: "M10.873 8.448c0 4.531-2.41 20.822-5.382 20.822C2.52 29.27.11 12.98.11 8.448S2.52.243 5.49.243c2.973 0 5.382 3.673 5.382 8.205",
  mask: "url(#d)"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#FFE200",
  fillRule: "nonzero",
  d: "M263.812 66.176c-1.501 4.277-4.62 20.447-1.815 21.43 2.804.985 10.47-13.59 11.97-17.867 1.5-4.276.443-8.54-2.362-9.525-2.804-.982-6.294 1.686-7.793 5.962"
}), /*#__PURE__*/React.createElement("g", {
  transform: "rotate(-30 368.389 -498.483)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "f",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#e"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#FFE200",
  fillRule: "nonzero",
  d: "M21.627 10.938c-4.495.57-20.96.233-21.335-2.715C-.082 5.274 15.775.83 20.271.26c4.495-.571 8.443 1.357 8.818 4.305.374 2.949-2.967 5.802-7.462 6.373",
  mask: "url(#f)"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#FFE200",
  fillRule: "nonzero",
  d: "M140.966 130.852c4.488.637 20.28 5.308 19.863 8.25-.418 2.943-16.886 3.043-21.372 2.408-4.487-.636-7.786-3.537-7.369-6.48.417-2.942 4.392-4.813 8.879-4.177"
}), /*#__PURE__*/React.createElement("g", {
  transform: "rotate(-30 438.896 -147.821)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "h",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#g"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#FFE200",
  fillRule: "nonzero",
  d: "M7.49 11.018c4.496.57 20.96.233 21.335-2.716C29.2 5.354 13.342.911 8.847.34 4.35-.231.403 1.696.028 4.645c-.374 2.948 2.967 5.802 7.462 6.373",
  mask: "url(#h)"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M269.373 176.277c-.76-1.582-1.222-3.304-1.54-5.023a10.52 10.52 0 01-.174-2.348c.003-.062.034-.3.082-.52.075.089.197.204.325.4 2.328 3.583 4.325 7.746 5.208 11.934.11.519.183 1.042.228 1.566a24.023 24.023 0 01-4.13-6.01m-19.525-.963c.971 1.386 1.674 3.38 2.103 4.312a40.362 40.362 0 011.966 5.261c-2.177-2.89-3.763-6.226-4.069-9.573m35.64 13.289c-2.784-.301-5.387-1.298-7.712-2.765.633-4.003-.51-8.231-2.073-11.873-.956-2.226-2.092-4.357-3.27-6.472-1.133-2.04-2.39-3.602-4.827-3.872-2.174-.24-3.626 1.948-4.17 3.712-.626 2.036-.092 4.47.374 6.484.944 4.066 3.103 7.761 5.8 10.905a24.463 24.463 0 003.1 3.017 10.817 10.817 0 01-2.027 3.248c-2.712 2.986-6.345 2.527-9.523.578a22.43 22.43 0 01-1.57-1.058 80.03 80.03 0 00-.465-2.526c-.814-4.023-2.227-7.914-3.987-11.617-1.46-3.067-3.399-6.62-7.224-6.73-1.23-.033-2.004.976-2.118 2.097-.82 8.1 3.79 15.552 9.777 20.749.275 2.14.394 4.301.388 6.461-.007 2.377-.394 6.262-2.99 7.297-2.415.961-5.812-.807-7.92-1.898-1.544-.799-2.963-1.786-4.278-2.903a49.98 49.98 0 00-.517-2.716c-.78-3.545-2.051-6.976-3.608-10.249-1.301-2.731-3.336-6.449-6.916-6.05-1.04.117-2.246.862-2.12 2.098.715 7.03 3.77 13.432 8.767 18.434.169.17.347.331.52.496.815 5.412.538 11.017-.656 16.336-.536 2.388 3.064 3.375 3.68.985a46.96 46.96 0 001.414-13.895 29.933 29.933 0 003.564 1.902c3.357 1.506 7.092 2.577 10.554.819 3.233-1.64 4.259-5.747 4.634-9.02.18-1.571.202-3.18.115-4.794 2.948 1.56 6.284 2.221 9.545.903 3.001-1.214 5.193-3.63 6.588-6.467a26.681 26.681 0 008.522 3.068c3.4.595 4.057-4.314.63-4.684"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M283.78 177.645c4.934 23.503 9.472 47.104 13.388 70.798.468 2.837 4.883 2.192 4.41-.64-3.958-23.71-8.54-47.296-13.957-70.716-.558-2.416-4.359-1.904-3.842.558m-59.618 32.754c16.799 17.163 33.315 34.621 49.359 52.494 1.92 2.139 5.295-.78 3.373-2.913-16.086-17.862-32.63-35.284-49.793-52.118-1.77-1.736-4.7.74-2.939 2.537"
}))), /*#__PURE__*/React.createElement("path", {
  fill: "#C5C7C8",
  fillRule: "nonzero",
  d: "M33.842 144.034a4.31 4.31 0 112.375 8.285 4.31 4.31 0 01-2.375-8.285zm-10.688-37.275c4.575-1.312 9.346 1.333 10.658 5.908s-1.333 9.346-5.908 10.658a8.616 8.616 0 01-10.658-5.908 8.616 8.616 0 015.908-10.658zm81.09-78.96c15.097-4.33 30.845 4.399 35.174 19.496 4.33 15.097-4.4 30.844-19.497 35.173-15.098 4.33-30.845-4.4-35.174-19.496-4.329-15.098 4.4-30.845 19.498-35.174zM42.653 55.96c9.804-2.81 20.03 2.857 22.84 12.661 2.812 9.803-2.856 20.029-12.66 22.84-9.803 2.81-20.029-2.857-22.84-12.66-2.81-9.804 2.857-20.03 12.66-22.84zm15.286 349.638c0 16.424 112.231 24.311 153.591 24.311 87.562 0 98.789-12.02 98.789-25.14 0-16.325-35.41-21.715-94.706-21.715-47.242 0-157.674 10.834-157.674 22.544"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#444A4F",
  fillRule: "nonzero",
  d: "M203.36 425.707c76.315 0 118.568-22.61 97.791-34.845-13.42-7.808-53.849-18.597-116.2-18.597-101.64 0-127.76 19.12-127.76 30.831 0 17.616 104.81 22.611 146.17 22.611z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#212427",
  d: "M57.192 403.096c0 17.616 104.808 22.611 146.168 22.611 55.28 0 84.061-7.493 95.73-18.32-12.04 4.893-29.409 12.566-96.831 12.566-63.395 0-132.44-4.442-145.067-16.857"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#5F6469",
  d: "M130.949 374.53c0 4.345 32.76 22.087 74.12 22.087 48.158 0 65.737-3.098 84.796-10.695-13.324-4.587-33.689-10.286-77.376-13.103-35.973-2.32-81.54 1.71-81.54 1.71z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#444A4F",
  fillRule: "nonzero",
  d: "M100.778 379.425c-5.824-10.074-10.394-21.007-14.34-31.932-4.511-12.499-8.29-25.461-10.435-38.594-2.178-13.36-3.254-26.636-2.712-40.168.445-11.121 1.937-22.998 5.59-33.547 3.53-10.845 7.868-21.195 13.908-30.907 6.801-10.94 15.04-20.45 24.333-29.336 9.786-9.36 21.052-17.068 32.657-23.978 2.485-1.48 5.969-2.94 7.938-5.152 3.468-3.894 2.126-10.254-2.639-12.393-3.458-1.553-6.394-.06-9.424 1.505-5.159 2.67-10.385 5.213-15.338 8.249-5.543 3.398-10.965 6.808-16.232 10.619-5.342 3.868-10.344 8.027-15.361 12.312-19.034 16.258-32.676 38.18-41.713 61.284-8.508 21.762-11.297 46.736-9.952 69.965 1.553 26.928 7.243 53.432 16.812 78.663 2.417 6.378 5.03 12.693 8.053 18.813 1.13 1.703 6.763 2.552 13.107.893 11.09-2.892 19.31-8.688 17.196-13.235-.42-.9-.807-1.953-1.448-3.061"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#5F6469",
  d: "M100.778 379.425c-5.824-10.074-10.394-21.007-14.34-31.932-4.511-12.499-8.29-25.461-10.435-38.594-2.178-13.36-3.254-26.636-2.712-40.168.445-11.121 1.937-22.998 5.59-33.547 3.53-10.845-17.47 34.604-16.129 57.832 1.556 26.928 6.827 50.515 16.395 75.746 2.418 6.382 10.29 25.659 12.249 24.862 7.65-3.11 12.514-7.52 10.83-11.138-.42-.9-.807-1.953-1.448-3.061"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#212427",
  d: "M145.652 134.924c3.032-1.569 5.969-3.058 9.427-1.508 4.765 2.14 6.107 8.499 2.639 12.396-1.8 2.02-11.424 7.36-13.832 8.714-3.2-1.373 0-11.477 1.766-19.602z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#5F6469",
  d: "M148.83 139.56l-.06.282c-1.61 7.732-1.465 14.303 6.268 15.915l15.532 3.24 5.896-28.279-15.532-3.242c-7.731-1.61-10.494 4.355-12.104 12.083"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#212427",
  d: "M161.008 157.004l9.562 1.992 5.897-28.277-9.563-1.996z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#444A4F",
  fillRule: "nonzero",
  d: "M172.168 123.036l-10.402 49.867 54.894 11.447 10.397-49.867c3.127-15.009-6.497-29.711-21.504-32.839l-.549-.117c-15.006-3.128-29.709 6.501-32.837 21.508"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#5F6469",
  d: "M185.099 119.821l-11.54 55.54 31.31 6.53 11.537-55.543c3.129-15.006-4.556-23.918-10.971-24.728-6.415-.81-.314-.066-.314-.066-8.56-1.784-16.894 3.26-20.023 18.266"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#212427",
  d: "M161.768 172.905l2.072-9.947c7.493-1.794 16.096-2.01 25.977.055 12.474 2.6 21.639 7.701 28.337 14.183l-1.493 7.155-54.893-11.446z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#444A4F",
  fillRule: "nonzero",
  d: "M116.355 229.022c-1.017 4.873 24.292 14.275 56.526 20.997 32.233 6.72 59.187 8.217 60.204 3.343 1.017-4.877 17.016-74.615-42.746-87.077-59.762-12.46-72.968 57.86-73.984 62.736z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#5F6469",
  d: "M191.39 166.316c-34.58-7.193-45.815 57.213-46.58 60.88-.766 3.667 9.422.515 33.68 5.575 24.257 5.06 42.779 16.323 43.543 12.653.765-3.67 14.334-69.751-30.643-79.108"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#212427",
  d: "M176.56 232.364c-32.232-6.721-59.189-8.22-60.205-3.344-1.017 4.874 24.292 14.276 56.527 21 32.232 6.718 59.186 8.215 60.204 3.341 1.018-4.875-24.29-14.276-56.524-20.997"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#C5C7C8",
  fillRule: "nonzero",
  d: "M153.985 137.432a4.421 4.421 0 004.014 7.878 4.417 4.417 0 001.93-5.944 4.419 4.419 0 00-5.945-1.933"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#5F6469",
  d: "M154.164 137.783a4.027 4.027 0 003.656 7.176c.748-.38-2.042.149-3.51-2.73-1.345-2.642.44-4.745-.146-4.446m111.717 232.056h-.096c-2.635 0-4.771.858-4.771 1.8v5.517s1.002.63 4.88.63c3.875 0 4.752-.63 4.752-.63v-5.517c0-.73-2.133-1.8-4.765-1.8"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#212427",
  d: "M265.772 383.714h.118c3.283 0 5.94-1.07 5.94-2.241v-6.87s-1.892.263-6.074.263c-4.006 0-5.921-.262-5.921-.262v6.869c0 .906 2.658 2.241 5.937 2.241"
}));

function SvgNoEnergyContracts(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 555,
    height: 431,
    viewBox: "0 0 555 431",
    preserveAspectRatio: "xMidYMid meet",
    color: "#000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoEnergyContracts);
var MemoForwardRef = /*#__PURE__*/React.memo(ForwardRef);
export default __webpack_public_path__ + "static/media/noEnergyContracts.0c110aed.svg";
export { MemoForwardRef as ReactComponent };